<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">그룹레슨 관리</span>
            <span class="txt">그룹레슨을 생성등록, 수정, 삭제가 가능합니다.</span>
        </div>

        <div class="top-info-lesson">
            <p class="com-sub-title">히스토리 내역</p>
            <p class="info-txt">
                <span class="txt">{{ name }}</span>
                <span class="txt">{{ convertWeek(week) }}</span>
                <span class="txt">{{ convertTime(time) }}({{ convertMinutes(totaltime) }})</span>
            </p>
        </div>

        <div class="com-search-content">
            <div class="line">
                <div class="com-calendar-wrap">
                    <single-calendar :start-date="startDate" @update="startDateUpdate"></single-calendar>
                    <div class="com-dash"><span class="dash">~</span></div>
                    <single-calendar :end-date="endDate" @update="endDateUpdate"></single-calendar>
                </div>
                <select-form
                    :select-data="['선택', ...periodTypeList]"
                    :select-value="['', ...periodTypeValueList]"
                    :selected-value="searchPeriod"
                    @update:set="(val) => (searchPeriod = val)"
                ></select-form>
                <select-form
                    :select-data="['전체', '등록', '종료', '휴강', '수업기간', '수업시간변경', '인원변경', '프로그램명', '카테고리', '자동예약', '단건수정']"
                    :select-value="['', 'CR', 'EX', 'HU', 'PE', 'TM', 'MC', 'PR', 'CT', 'MF', 'SC']"
                    :selected-value="eventType"
                    @update:set="(val) => (eventType = val)"
                ></select-form>
                <div class="com-search-input">
                    <input v-model="searchStr" placeholder="내용 입력" type="text" v-on:keyup.enter="onEventSearch" />
                    <button class="search-btn" @click="onEventSearch">검색</button>
                </div>
            </div>
        </div>

        <div class="com-table-content">
            <table class="com-table">
                <colgroup>
                    <col style="width: 300px" />
                    <col style="width: 240px" />
                    <col style="width: 710px" />
                    <col style="width: 180px" />
                </colgroup>
                <thead>
                    <tr>
                        <th>수정시간</th>
                        <th>수정내역</th>
                        <th>내용</th>
                        <th>입력자</th>
                    </tr>
                </thead>
                <tbody>
                    <!-- <tr>
                    <td>2020-01-22 10:54:22</td>
                    <td>종료</td>
                    <td class="left">월,수 14:00 (1시간) 그룹레슨이 종료되었습니다.</td>
                    <td>김윤경</td>
                </tr>
                <tr>
                    <td>2020-01-22 10:54:22</td>
                    <td>휴강</td>
                    <td class="left"><span class="red">2019-12-25</span> 그룹레슨이 인원 미달로 강제휴강 되었습니다.</td>
                    <td>김윤경</td>
                </tr>
                <tr>
                    <td>2020-01-22 10:54:22</td>
                    <td>프로그램명</td>
                    <td class="left"><span class="red">2019-12-25</span> 프로그램명이 <span class="blue">바디프로필 프로젝트반</span>에서 <span class="blue">리포머 필라테스</span>으로(로) 수정되었습니다.</td>
                    <td>김윤경</td>
                </tr>
                <tr>
                    <td>2020-01-22 10:54:22</td>
                    <td>수업기간</td>
                    <td class="left">수업기간이 <span class="blue">2019-08-20 ~ 2019-12-20</span>에서 <span class="blue">2019-08-20 ~ 2020-08-20</span>으로(로) 변경되었습니다.</td>
                    <td>김윤경</td>
                </tr> -->
                    <tr v-for="(h, index) in historyList" :key="index">
                        <td>{{ h.clseh_upd_dt | timestampFilter2 }}</td>
                        <td>{{ convertCode(h.clseh_event_type_cd) }}</td>
                        <td class="left">{{ h.clseh_event_content }}</td>
                        <td>{{ h.clseh_name }}</td>
                    </tr>
                    <tr v-if="historyList.length === 0">
                        <td colspan="100">등록된 내용이 없습니다.</td>
                    </tr>
                </tbody>
            </table>
            <div class="sort-bottom-area">
                <button class="com-btn excel" @click="excelDownload">엑셀 다운로드</button>
                <select-form
                    :select-data="[...sortTypeList]"
                    :select-value="[...sortTypeValueList]"
                    class="float-right"
                    @update:set="changeLimit"
                ></select-form>
            </div>
        </div>
        <b-pagination
            v-model="pagingInfo.page"
            :per-page="pagingInfo.limit"
            :total-rows="pagingInfo.totalItems"
            align="center"
            aria-controls="my-table"
            first-class="first"
            last-class="last"
            next-class="next"
            prev-class="prev"
            @change="handlerPagenation($event)"
        ></b-pagination>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import moment from 'moment';
import XLSX from 'xlsx';
import { pagingInfo } from '@/assets/js/common';
export default {
    name: 'CourseHistory',
    props: {},
    computed: {
        cId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
    },
    watch: {
        searchPeriod: function (newValue) {
            this.searchPeriod = newValue;

            if (newValue === 'today') {
                // 오늘
                this.startDate = moment().format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'yesterday') {
                // 어제
                this.startDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
                this.endDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
            } else if (newValue === 'thisMonth') {
                // 이번 달
                this.startDate = moment().startOf('month').format('YYYY-MM-DD');
                this.endDate = moment().endOf('month').format('YYYY-MM-DD');
            } else if (newValue === 'prevMonth') {
                // 지난 달
                this.startDate = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
                this.endDate = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
            } else if (newValue === '3M') {
                // 3개월
                this.startDate = moment().subtract(3, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === '6M') {
                // 6개월
                this.startDate = moment().subtract(6, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === '12M') {
                // 12개월
                this.startDate = moment().subtract(12, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === '') {
                this.initStartDate();
                this.initEndDate();
            }
            this.onSearchList();
        },
        startDate: function (newValue) {
            this.startDate = newValue;
        },
        endDate: function (newValue) {
            this.endDate = newValue;
        },
        eventType: function (newValue) {
            this.eventType = newValue;
            this.onSearchList();
        },
    },
    data() {
        return {
            centerLessonScheduleMasterId: this.$route.params.id,

            name: this.$route.params.name,
            time: this.$route.params.time,
            week: this.$route.params.week,
            totaltime: this.$route.params.total,

            centerId: '',
            historyList: [],
            pagingInfo: { ...pagingInfo },
            period: '',
            startDate: '',
            endDate: '',
            searchStr: '',
            searchPeriod: '', // 검색기간 설정

            periodTypeList: [...this.$periodTypeList],
            periodTypeValueList: [...this.$periodTypeValueList],
            sortTypeList: [...this.$sortType],
            sortTypeValueList: [...this.$sortTypeValue],
            eventType: '', //이벤트타입
        };
    },
    mounted() {
        this.centerId = this.cId; // 센터 Id
        this.init();
        this.onSearchList();
    },
    methods: {
        async init() {
            this.pagingInfo.page = 1;
            this.pagingInfo.limit = 10;
            this.initStartDate(); // 검색 시작일 초기화
            this.initEndDate(); // 검색 종료일 초기화
        },

        async onSearchList() {
            try {
                const { data } = await this.getSearchList();
                this.historyList = data.items;
                console.log('history', data);
            } catch (error) {
                console.log(error);
            }
        },
        // 스웨거 검색: 그룹레슨 히스토리 페이징 목록 조회
        getSearchList() {
            return api.get(
                `/admin/api/center/${this.centerId}/lesson/${this.centerLessonScheduleMasterId}/group/history`,
                {
                    params: {
                        searchStr: this.searchStr,
                        startDate: moment(this.startDate).format('YYYYMMDD'),
                        endDate: moment(this.endDate).format('YYYYMMDD'),
                        eventType: this.eventType,
                        ...this.pagingInfo,
                    },
                }
            );
        },
        // 한 페이지에 표시되는 줄 수 변경
        changeLimit(val) {
            this.pagingInfo.limit = val;
            this.onSearchList();
        },

        // 페이징 이벤트
        handlerPagenation(event) {
            this.pagingInfo.page = event;
            this.onSearchList();
        },

        // 검색 시작일 초기화
        initStartDate() {
            const startDate = moment().subtract(1, 'years').format('YYYY-MM-DD');
            this.startDate = startDate;
        },

        // 검색 종료일 초기화
        initEndDate() {
            const endDate = moment().format('YYYY-MM-DD');
            this.endDate = endDate;
        },

        // 검색 시작일 변경 event
        startDateUpdate(val) {
            this.startDate = val;
        },

        // 검색 종료일 변경 event
        endDateUpdate(val) {
            this.endDate = val;
        },
        // 페이징 Param 설정
        setPageParams(data) {
            this.pagingInfo.totalPages = data.meta.totalPages;
            this.pagingInfo.page = data.meta.currentPage;
            this.pagingInfo.totalItems = data.meta.totalItems;
            this.pagingInfo.itemCount = data.meta.itemCount;
        },
        // 키워드 검색 이벤트
        onEventSearch(e) {
            if (this.searchStr.length > 0 && this.searchStr.length < 2) {
                return;
            }
            this.onSearchList();
        },
        //수업요일 변환
        convertWeek(weeks) {
            let week1 = weeks.split(':');
            console.log(week1);
            let week = ['월', '화', '수', '목', '금', '토', '일'];
            let str = '';
            for (let i = 0; i < week1.length; i++) {
                if (week1[i] == 'O') str += `${week[i]}/`;
            }
            return str.slice(0, -1);
        },
        //시간 변환
        convertMinutes(minutes) {
            if (minutes == 30) {
                return '30분';
            } else if (minutes == 60) {
                return '1시간';
            } else if (minutes == 90) {
                return '1시간30분';
            } else if (minutes == 120) {
                return '2시간';
            } else if (minutes == 180) {
                return '3시간';
            }
        },
        convertTime(time) {
            return time.substring(0, 5);
        },
        convertCode(code) {
            if (code == 'CR') {
                return '등록';
            } else if (code == 'EX') {
                return '종료';
            } else if (code == 'HU') {
                return '휴강';
            } else if (code == 'PE') {
                return '수업기간';
            } else if (code == 'TM') {
                return '수업시간변경';
            } else if (code == 'MC') {
                return '인원변경';
            } else if (code == 'PR') {
                return '프로그램명';
            } else if (code == 'CT') {
                return '카테고리';
            } else if (code == 'MF') {
                return '자동예약';
            }else if (code == 'SC') {
                return '단건수정';
            }
        },
        // 엑셀 다운로드 기능
        excelDownload() {
            let excelDownloadArray = [];
            /*
            const { data } = await this.getMembersListExcel(); // 엑셀용 요청값

            let excelDownloadArray = [];
            data.items.forEach(member => {
                const temp = {};
                temp['회원명'] = member.cc_customer_name;
                temp['유효기간'] = `${timestampToDate(member.cc_exp_start_dt)}~${timestampToDate(member.cc_exp_end_dt)}`;
                temp['이용권명'] = `${this.ticketTypeStringExcel(member.cp_ticket_type_cd)}${member.cc_lesson_name}`;
                temp['이용권현황'] = this.ticketCntStringExcel(member.cc_less_join_cnt, member.cc_less_absn_cnt, member.cc_less_cnt);
                temp['구매가'] = `${numberFormat(member.cc_total_buy_price)}원`;
                temp['결제정보'] = this.paymentInfoStringExcel(member.cc_bill_info, member.cc_total_debt_price);
                temp['등록구분'] = this.convertContractType(member.cc_contract_type_cd);
                temp['담당강사'] = member.cc_staff_name;
                temp['등록일자'] = timestampToDate(member.cc_cre_dt);
                temp['센터명'] = member.cc_center_nm;

                excelDownloadArray.push(temp);
            });
            */

            /*[Key:value, ...]*/
            const dataWS = XLSX.utils.json_to_sheet(excelDownloadArray);

            // cell width 설정
            const wscols = [
                { wch: 12 },
                { wch: 24 },
                { wch: 50 },
                { wch: 30 },
                { wch: 12 },
                { wch: 35 },
                { wch: 12 },
                { wch: 12 },
                { wch: 12 },
                { wch: 12 },
                { wch: 12 },
            ];
            dataWS['!cols'] = wscols;

            // cell height 설정
            const wsrows = [{ hpx: 30 }];
            dataWS['!rows'] = wsrows;

            const wb = XLSX.utils.book_new();

            XLSX.utils.book_append_sheet(wb, dataWS, '히스토리 내역');
            XLSX.writeFile(wb, '히스토리 내역.xlsx');
        },
    },
};
</script>
<style lang="scss"></style>
